import React from "react";
import { Grid, FormControlLabel, Button, Checkbox } from "@material-ui/core";
import { inject, observer } from "mobx-react";
import FormulaDataType from "./common/FormulaDataType";
import CodeSnippetPopup from "./CodeSnippetPopup";

function CodeSnippetColumnConfig(props) {
  const { values, handleChange, setFieldValue, store } = props;
  const [anchorEl, setAnchorEl] = React.useState(null);
  const setReviseButtonRef = React.useCallback(
    (node) => {
      if (node !== null && !values.formula) {
        setAnchorEl(node);
      }
    },
    [values.formula]
  );

  React.useEffect(() => {
    setFieldValue("options.apply_formula", values.options["apply_formula"]);
  }, [setFieldValue]);

  return (
    <React.Fragment>
      <Grid item xs={12}>
        <Button
          ref={setReviseButtonRef}
          onClick={(e) => {
            if (!values.column_name) {
              return Ext.Msg.alert("Error", "Please enter column name");
            }
            setAnchorEl(e.target);
          }}
          variant="outlined"
        >
          Revise
        </Button>
        <CodeSnippetPopup
          anchorEl={anchorEl}
          formula={values.formula ?? ""}
          onClose={() => setAnchorEl(null)}
          onSave={(formula) => {
            setFieldValue("formula", formula);
            setAnchorEl(null);
          }}
          columnName={values.column_name}
          columnAliasNames={store.codeSnippetColumnAliasNames}
          validateCodeSnippet={store.validateCodeSnippet}
          columnTypeId={values.column_type_id}
        />
      </Grid>
      <FormulaDataType {...props} />
      <Grid item xs={12}>
        <FormControlLabel
          control={
            <Checkbox
              size="small"
              color="primary"
              name={`options.apply_formula`}
              checked={values.options["apply_formula"]}
              onChange={handleChange}
            />
          }
          label={"Apply formula for all rows in current sheet"}
        />
      </Grid>
    </React.Fragment>
  );
}

export default inject(({ store: appStore }) => ({
  // columnAliasNames: appStore.addColumnStore.codeSnippetColumnAliasNames,
  // validateCodeSnippet: appStore.addColumnStore.validateCodeSnippet,
}))(observer(CodeSnippetColumnConfig));
